import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CheckAuthGuard } from './guards/check-auth.guard';
import { ExternalRedirectComponent } from './redirect/external-redirect.component';


const routes: Routes = [

	{
		path: '',
		loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
	},
	{
		path: 'cestaurbana-adm',
		children: [
		  {
			path: '**',
			component: ExternalRedirectComponent,
		  },
		],
	  },
	  {
		path: 'adm-commerce',
		children: [
		  {
			path: '**',
			component: ExternalRedirectComponent,
		  },
		],
	  },

	{
		path: 'payment-success',
		loadChildren: () => import('./pages/payment-success/payment-success.module').then(m => m.PaymentSuccessModule),
	},
	{
		path: 'payment-error',
		loadChildren: () => import('./pages/payment-error/payment-error.module').then(m => m.PaymentErrorModule),
		 canLoad: [CheckAuthGuard], canActivate: [CheckAuthGuard]
	},
	{ path: '**', redirectTo: '/404' },

];

@NgModule({
	imports: [RouterModule.forRoot(routes, {
		//  onSameUrlNavigation: 'reload'
		scrollPositionRestoration: 'enabled',
		anchorScrolling: 'enabled',
		scrollOffset: [0, 64] // [x, y]
	})],
	exports: [RouterModule]
})
export class AppRoutingModule { }


